import React, { useCallback, useEffect, useState } from "react"
import { SubscriptionFeature } from "../types/membership/membershipTypes"
import { toValidNumber } from "../utils/helpers";
import { Link } from "react-router-dom";
import Badge from "../components/badges/Badge";
import MembershipSkeleton from "../skeletons/MembershipSkeleton";
import { AppDispatch, RootState, store } from "../redux-stores/store";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchMembershipData } from "../redux-stores/slices/membershipSlice";
import { FREE_SUBSCRIPTION_PLAN_ID, WEB_APP_URL } from "../constants/constants";
import inPopup from "../utils/hoc/inPopup";
import { analyticsLog } from "../lib/analytics";

const ManageMembership: React.FC<{ isActive: boolean; onClose: () => void; }> = ({ onClose }) => {
    const token = store.getState().auth.token;
    const encodedToken = btoa(token || ''); // URL encode the token

    return (
        <div className="p-3">
            <div className="modal-header border-0">
                <h4 className="modal-title fw-bold">Manage Membership</h4>
                <button type="button" className="btn-close rounded-circle bg-light" onClick={onClose}></button>
            </div>

            <div className="modal-body py-3 pb-0">
                <span>
                    You are about to leave the app and redirected to <a target="_blank" href={WEB_APP_URL}>{WEB_APP_URL}</a> for managing your membership plan.
                </span>
            </div>
            <div className="divider my-3"></div>
            <div className="border-0 d-flex justify-content-between gap-2">
                <button className="btn btn-sm w-50 btn-secondary rounded-sm" onClick={onClose}>Cancel</button>
                <a href={WEB_APP_URL + `/i/pricing?token=${encodedToken}`} className="btn btn-sm w-50 theme-btn-primary rounded-sm" target="_blank">Continue</a>
            </div>
        </div>
    )

}

const ManageMembershipPopup = inPopup(ManageMembership)

const Membership: React.FC = () => {

    const dispatch:AppDispatch = useDispatch();

    const {loading, active_plan: activePlan, subscription_features: subscriptionFeatures} = useSelector((state: RootState) => state.membership);
    
    const fetchData = useCallback(async (force=false) => {
        dispatch(fetchMembershipData(force))
    }, [dispatch])

    useEffect(() => {
        if(activePlan){
            analyticsLog('subscription_view', {
                plan: activePlan.plan?.name
            })
        }
    }, [activePlan])

    useEffect(() => {
        fetchData();
    }, [fetchData])

    if (loading) return <MembershipSkeleton />

    return (
        <div className="card card-style py-2 position-relative border">
            <div className="content">
                {/* <img src="images/undraw/1.svg" width="250" className="mx-auto" /> */}
                <h1 className="text-center pt-3 font-30 mb-2 pop">{activePlan?.plan?.name}</h1>
                {/* <p className="text-center color-highlight font-600"></p> */}
                {
                    activePlan?.platform &&
                    <React.Fragment>
                        <div className="divider"></div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex flex-column">
                                {
                                    activePlan?.platform &&
                                    <React.Fragment>
                                        <span className="text-gray-500">Started:</span>
                                        <span className="text-gray-900">{activePlan.started_date}</span>
                                    </React.Fragment>
                                }
                            </div>
                            <h1 className="font-40 text-center">
                                <sup className="price-sup font-22">₹</sup>
                                {toValidNumber(activePlan?.billing_amount)}
                                {/* <sup className="price-sup font-14">.99</sup> */}
                            </h1>
                            <div className="d-flex flex-column justify-content-end align-items-end">
                                {
                                    activePlan?.platform &&
                                    <React.Fragment>
                                        <span className="text-gray-500">Next Due:</span>
                                        <span className="text-gray-900">{activePlan.next_due_date}</span>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </React.Fragment>
                }


            </div>
            <div className="table-responsive px-3 ">
                <table className="table align-middle table-row-dashed o">
                    <thead>
                        <tr className="border-bottom">
                            <th>Feature</th>
                            <th className="text-end">Usage</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            subscriptionFeatures && Object.values(subscriptionFeatures).map((sf: SubscriptionFeature, i: number) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            <label>{sf.name}</label>
                                            {/* <div>{sf.description}</div> */}
                                        </td>
                                        <td className="text-end">
                                            {
                                                sf.type === 'consumable' &&
                                                <span>{sf.consumed_limit}/{sf.applicable_limit}</span>
                                            }
                                            {
                                                sf.type !== 'consumable' &&
                                                <React.Fragment>
                                                    {
                                                        sf.applicable_limit ? <i className="fa fa-check-circle color-green-dark"></i> : <i className="fa fa-times-circle color-red-dark"></i>
                                                    }
                                                </React.Fragment>
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center pb-2">
                <Link to='/subscription-plans' className="btn w-100 mx-3 btn-primary text-center rounded-sm btn-sm">{activePlan?.plan.id === FREE_SUBSCRIPTION_PLAN_ID ? "Buy Subscription" : "Upgrade"}</Link>
            </div>
            <span className="featured-badge bg-highlight">Active Plan</span>
        </div>
    )
}

export default Membership